export default "__VITE_ASSET__78b3cec9__"